import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../AnimationContents';
import { GameLogic } from '../Logic/GameLogic';

export class PreloaderGameController
    extends AnimationLoadingBaseController
    implements ILoadingBaseController
{
    public $model;

    private _menuBgWidth: number = 0;
    private _menuBgHeight: number = 0;

    public constructor(@Inject private _options: any) {
        super('PreloaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: 'preloader_screen',
        };
    }

    protected onInitialize(): void {

        this._menuBgWidth = this.width;
        this._menuBgHeight = this.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        let sizeW = width / scale;
        let sizeH = height / scale;

        

        const containerScale = Math.min(sizeW / 1920, sizeH / 1440);
        this.scaleX = containerScale;
        this.scaleY = containerScale;
        const bgScale = Math.max(sizeW / 3000, sizeH / 3000);
        const bg = this.getDisplayObjectByQuery('bg')[0];
            bg.scale.x = bgScale / containerScale;
            bg.scale.y = bgScale / containerScale;
            //@ts-ignore
            bg.anchor.x = 0.5;
            //@ts-ignore
            bg.anchor.y = 0.5;
            bg.x = 0;
    }

    public onLoadingProgress(progress: number): void {
        
    }

    public onHide(): void {
    }

    public onShow(): void {}
}
